import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea, Stack } from '@mui/material';
import { Box, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion'
import { GitHub, Link } from '@mui/icons-material';

function Project({ img, title, desc, live, github, delay = 0, technology }) {
    return (
        <Grid item>
            <motion.div
                initial={{
                    x: "-100%",
                    opacity: 0,
                }}
                whileInView={{
                    x: 0,
                    opacity: 1,
                }}
                transition={{
                    delay: delay,
                    type: "spring",
                    ease: "linear",
                }}
                style={{
                    height: "100%"
                }}
            >
                <Card sx={{ maxWidth: 345, height: "100%" }}>
                    <CardActionArea sx={{ height: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        <CardMedia
                            component="img"
                            height="180"
                            image={img}
                        />
                        <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                            <Typography gutterBottom variant="h5" component="div" sx={{ fontWeight: 600 }}>
                                {title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }} textAlign={"justify"}>
                                {desc}
                            </Typography>
                            <Typography component='p' variant='subtitle2' sx={{fontWeight: 600}} color="primary" mt={1}>
                                Technology Used: <Typography variant='body2' component='span' sx={{fontWeight: 500}} color={'darkgrey'} >{technology}</Typography>.
                            </Typography>
                            <Stack direction={"row"} mt={"auto"} sp>
                                <Button href={live} target='_blank' startIcon={<Link />} >Live</Button>
                                <Button href={github} target='_blank' startIcon={<GitHub />} >Github</Button>
                            </Stack>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </motion.div>
        </Grid>
    )
}

export default Project